import React from 'react'

export const PlusIconWhite = (props) => (
  <svg width={10} height={11} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.188 10.96V6.772H0V5.17h4.188V.96h1.624v4.21H10v1.602H5.812v4.188H4.188Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.25}
    />
  </svg>
)
